/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type { JPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const precalculateFormulaFieldAllValuesSelector: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.formula-field.precalculate-all-values-selector', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
